import React from 'react';
import {
  ShieldOutlined,
  MonitorHeartOutlined,
  FactCheckOutlined,
  NotificationsActiveOutlined,
  PaidOutlined,
  CloudOutlined,
  CircleOutlined,
} from '@mui/icons-material';
import { sourceCategory, type CategoryKey } from '../utils/eventDisplay';

const CATEGORY_ICON: Record<CategoryKey, { Icon: typeof ShieldOutlined; color: string }> = {
  security: { Icon: ShieldOutlined, color: 'error.main' },
  health: { Icon: MonitorHeartOutlined, color: 'success.main' },
  config: { Icon: FactCheckOutlined, color: 'warning.main' },
  compute: { Icon: NotificationsActiveOutlined, color: 'info.main' },
  cost: { Icon: PaidOutlined, color: 'secondary.main' },
  cloud: { Icon: CloudOutlined, color: 'primary.main' },
  other: { Icon: CircleOutlined, color: 'text.disabled' },
};

/** Coloured category glyph for an event source, shared by the table and detail. */
const CategoryIcon: React.FC<{ source: string; size?: number }> = ({ source, size = 16 }) => {
  const { Icon, color } = CATEGORY_ICON[sourceCategory(source)];
  return <Icon sx={{ fontSize: size, color, flexShrink: 0 }} />;
};

export default CategoryIcon;
